import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-anquan",
  "use": "icon-anquan-usage",
  "viewBox": "0 0 41.21 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 41.21 44\" id=\"icon-anquan\"><defs><style>#icon-anquan .cls-1{fill:#77b4f2;}#icon-anquan .cls-2{fill:#232a35;}</style></defs><title>9</title><path class=\"cls-1\" d=\"M17,38.87h0s13.79-7.19,17.92-18.21A17.84,17.84,0,0,0,35.64,18H17Z\" transform=\"translate(4.02 4)\" /><path class=\"cls-1\" d=\"M-1.64,18H17V3.62L-2.1-2.87S-3.18,10.27-1.64,18Z\" transform=\"translate(4.02 4)\" /><path class=\"cls-2\" d=\"M16.59,40a1.12,1.12,0,0,1-.53-.13c-.58-.3-14.22-7.52-18.45-18.82C-5,14.08-3.7-2.27-3.64-3a1.1,1.1,0,0,1,.51-.85,1.13,1.13,0,0,1,1-.13L16.59,2.42,35.32-3.94a1.13,1.13,0,0,1,1,.13,1.09,1.09,0,0,1,.5.85c.06.69,1.37,17-1.24,24-4.23,11.3-17.88,18.52-18.46,18.82A1.06,1.06,0,0,1,16.59,40ZM-1.48-1.32c-.26,4.17-.8,16.22,1.21,21.58,3.48,9.28,14.34,15.88,16.86,17.31,2.52-1.43,13.38-8,16.85-17.31,2-5.36,1.47-17.41,1.22-21.58L17,4.69a1.14,1.14,0,0,1-.73,0Z\" transform=\"translate(4.02 4)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/anquan.svg
// module id = yqot
// module chunks = 22